import { createPersistedStore, storage } from '@connect-x-app/hybrid-utils';
import { createSerializableStorage } from '@connect-x-app/shared-utils';

type QuickReplyState = {
  quickReplies: string[];
  setQuickReplies: (quickReplies: string[]) => void;
};

export const useQuickReplyStore = createPersistedStore<QuickReplyState>(
  (set, _) => ({
    quickReplies: [],
    setQuickReplies: quickReplies => {
      set(_ => ({
        quickReplies: quickReplies,
      }));
    },
  }),
  {
    name: 'quick-reply-store',
    storage: createSerializableStorage(storage),
  },
);
